export * from './loadingTemplate.types';
export { default as LoadingTemplate } from './loadingTemplate.component';
